























import ResultComponent from './Result.vue';
import DynamicTableResultComponent from './DynamicTableResult.vue';
import PhonebookResultComponent from './PhonebookResult.vue';
import PagerComponent from './Pager.vue';
import { Component, Vue } from 'vue-property-decorator';
import { Counter, Pager, Data, Result } from '@/models/dynamiclist';
import { Getter } from 'vuex-class';

@Component({
    components: {
        ResultComponent,
        PhonebookResultComponent,
        DynamicTableResultComponent,
        PagerComponent
    }
})
export default class ResultsComponent extends Vue {

    @Getter('counter')
    public counter!: Counter;

    @Getter('pager')
    public pager!: Pager;

    @Getter('data')
    public data!: Data;

    @Getter('results')
    public results!: Result[];

    public fieldCount(): number {
        return Object.keys(this.data.tableFields).length;
    }
}
